import { styled } from "@mui/system";

export const StyledOTPForm = styled("div", {
  shouldForwardProp: prop => prop !== "islamic"
})(({ theme, islamic }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginBottom: "unset"
  },
  [theme.breakpoints.only("xs")]: {
    marginTop: 0,
    boxSizing: "border-box"
  },
  "& .title": {
    "& div:nth-of-type(2) span": {
      fontSize: "0.75rem",
      lineHeight: "1rem",
      fontWeight: 500,
      [theme.breakpoints.up("sm")]: {
        fontSize: "1.25rem",
        lineHeight: "1.75rem",
        fontWeight: "unset"
      }
    },
    [theme.breakpoints.only("xs")]: {
      marginTop: 0
    }
  },
  "& .form": {
    height: "calc(100vh - 12rem)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.up("sm")]: {
      height: "100%"
    }
  },
  "& .error": {
    marginBottom: "10px"
  },
  "& .link": {
    fontSize: "0.75rem",
    cursor: "pointer",
    opacity: 1,
    visibility: "visible",
    float: "right",
    color: "#8D0C10",
    fontWeight: 500,
    lineHeight: "16px",
    letterSpacing: "0.064px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem"
    },
    "&.linkDisabled": {
      opacity: "0.5",
      cursor: "not-allowed"
    }
  },
  "& .submitButton": {
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
      margin: 0
    }
  },
  "& .otpExpireMsg": {
    color: "#757575",
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: "16px",
    margin: 0,
    [theme.breakpoints.up("sm")]: {
      fontSize: "1rem"
    }
  },
  "& .otpInputWrapper": {
    display: "flex",
    flexWrap: "nowrap",
    gap: "0.5rem",
    justifyContent: "space-between",
    alignItems: "flex-start",
    alignSelf: "stretch",
    [theme.breakpoints.up("sm")]: {
      gap: "1.5rem"
    }
  },
  "& .otpReseneLinkWrapper": {
    display: "flex",
    flexDirection: "column",
    gap: "1.81rem",
    marginTop: "2rem",
    [theme.breakpoints.up("sm")]: {
      gap: "2rem",
      marginTop: "2.5rem"
    }
  }
}));
